<template>
  <v-row no-gutters
         class="ml-6 mr-12 std-border-radius std-container-shadow">
    <v-col cols="12"
           class="hf-header-container std-border-top-radius std-text-white-1 d-flex align-center justify-center std-text-md font-weight-bold"
           :style="{backgroundColor: color + ' !important'}">
      {{header}}
      <div style="position:absolute; right: 56px"
           @click="close()"
           class="d-flex align-center std-pointer">
        <i class="std-icon hf-close-icon"></i>
      </div>
    </v-col>
    <v-col cols="12"
           class="hf-main-container std-border-bottom-radius">
      <v-row no-gutters class="full-height">
        <!-- left container -->
        <v-col cols="3">
          <v-row no-gutters justify="center">
            <v-col cols="11">
              <div class="hf-left-sm-container d-flex align-center flex-column">
                <!--suppress HtmlUnknownTarget -->
                <v-img height="80%"
                       contain
                       :src="img">
                </v-img>
                <div class="hf-break"></div>
              </div>
              <v-card class="hf-left-container d-flex align-center flex-wrap unselectable"
                      v-if="!single"
                      flat
                      @click="setLeftInd('first')"
                      :style="{color: this.color}">
                <div class="col-12 pa-0 align-self-end d-flex justify-center flex-wrap">
                  <div class="d-flex align-center hf-left-image-container"
                       :class="{'std-disabled': this.leftIndSelected !== 'first'}">{{cowsCount}}</div>
                  <div style="height: 43px"
                       :class="{'std-disabled': this.leftIndSelected !== 'first'}"
                       class="col-12 pa-0 std-text-md d-flex align-center justify-center ">{{leftIndicator.first.title}}</div>
                  <div class="hf-break"></div>
                </div>
              </v-card>
              <v-card class="hf-left-container d-flex flex-wrap justify-center unselectable"
                      flat
                      @click="setLeftInd('second')"
                      :class="{'std-disabled': this.leftIndSelected !== 'second'}"
                      :style="{color: this.color}">
                <div class="d-flex align-center hf-left-image-container">{{leftIndicator.second.number}}</div>
                <div style="height: 45px"
                     class="col-12 pa-0 std-text-md d-flex align-center justify-center">{{leftIndicator.second.title}}</div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <!-- end of left container -->
        <v-col cols="6">
          <v-row no-gutters>
            <v-col cols="12"
                   class="hf-table-container d-flex justify-center flex-wrap mt-5">
              <!-- inicio de header de tabla -->
              <div :style="{backgroundColor: this.color}"
                   class="std-table-header d-flex align-center justify-center col-11 px-0 std-text-md font-weight-bold">
                <div class="col-6 d-flex align-center pa-0 pl-4">
                  {{tableFirstColumn}}
                  <i class="std-vertical-arrow-icon"></i>
                </div>
                <div class="col-4 d-flex justify-center align-center pa-0 ">
                  {{tableSecondColumn}}
                  <i class="std-vertical-arrow-icon"></i>
                </div>
              </div>
              <!-- fin de header de tabla -->
              <!-- inicio de contenido de tabla -->
              <v-row no-gutters
                     class="col-12 pa-0"
                     style="height: 364px"
                     justify="center"
                     v-if="animals.length !== 0"
                     align-content="start">
                <v-col cols="11"
                       class="d-flex align-center justify-center std-table-row-container"
                       v-for="(item, index) in animals"
                       :key="index"
                       v-bind:class="[{'std-first-row' : index === 0}]">
                  <div class="col-6 d-flex align-center pa-0 pl-4">
                    <i class="dstable-cow-icon mr-2"></i>
                    {{item.idInternal.toString().slice(0, 6)}}
                  </div>
                  <div class="col-4 d-flex align-center justify-center pa-0">
                    {{view === 'health' ? item.health.sick : item.breed }}
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters
                     class="col-12 pa-0"
                     style="height: 364px"
                     justify="center"
                     v-else
                     align-content="start">
                <v-col cols="11"
                       class="full-height d-flex align-center justify-center">
                  <div class="col-12 pa-0 d-flex align-center justify-center flex-wrap">
                    <v-img src="../assets/home/sad_cow.png"
                           class="col-12 pa-0"
                           contain
                           max-width="240px">
                    </v-img>
                    <div class="std-text-md std-text-blue-2 col-12 pa-0 text-center mt-3">
                      Lo sentimos, no tenemos lo que buscas :(
                    </div>
                  </div>
                </v-col>
              </v-row>
              <!-- fin de contenido de tabla -->
            </v-col>
            <v-col cols="12"
                   class="hf-table-paginator d-flex align-center justify-center">
              <v-pagination v-model="pageSelected"
                            class="col-6 pa-0"
                            :color="this.color"
                            :disabled="itemsPage === 0"
                            :length="itemsPage"
                            :next-icon="nextIcon"
                            :prev-icon="prevIcon"
                            total-visible="10">
              </v-pagination>
            </v-col>
          </v-row>
        </v-col>

        <!-- right lateral panel -->
        <v-col cols="3"
               style="position: relative"
               class="mt-5">

          <!-- counter cards -->
          <v-row no-gutters
                 justify="space-around">
            <v-col cols="5"
                   :style="{backgroundColor: styleCow.background}"
                   @click="setSelectedAnl('cow')"
                   class="std-border-radius">
              <v-row no-gutters
                     :style="{borderColor: styleCow.border}"
                     class="hf-animal-count">
                <v-col col="5"
                       class="align-center d-flex justify-center">
                  <i class="std-icon pa-0" :class="styleCow.icon"></i>
                </v-col>
                <v-col col="5"
                       :style="{color: styleCow.color}"
                       class="std-text-md align-center d-flex justify-center font-weight-medium ">{{cowsCount}}</v-col>
              </v-row>
            </v-col>
            <v-col cols="5"
                   :style="{backgroundColor: styleCalf.background}"
                   class="std-border-radius"
                   @click="setSelectedAnl('calf')">
              <v-row no-gutters
                     :style="{borderColor: styleCalf.border}"
                     class="hf-animal-count">
                <v-col col="5"
                       class="d-flex align-center justify-center">
                  <i class="std-icon pa-0"
                     :class="styleCalf.icon"></i>
                </v-col>
                <v-col col="5"
                       :style="{color: styleCalf.color}"
                       class="std-text-md align-center d-flex justify-center font-weight-medium">{{heifersCount}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- end of counter cards -->

          <!-- heat date range cards -->
          <v-row no-gutters
                 v-if="this.view === 'heat'">
            <v-fade-transition>
              <v-col cols="12"
                     v-if="leftIndSelected === 'second'">
                <v-row no-gutters
                       class="mt-4 hf-right-header">
                  <v-col class="d-flex align-center justify-center std-text-md"
                         :style="{color: this.color}"
                         cols="12">Días de seguimiento
                  </v-col>
                </v-row>
                <v-row no-gutters
                       v-if="leftIndSelected === 'second'"
                       class="mt-2 px-6">
                  <v-col cols="12"
                         class="d-flex align-center flex-wrap">
                    <div class="col-12 pa-0">
                      <v-range-slider
                              dense
                              style="font-size: .875rem !important; color: #EB004E !important"
                              class="font-weight-medium"
                              hide-details
                              v-model="sliderHt"
                              min="18"
                              color="#979797"
                              track-color="#97F6D2"
                              :thumb-color="this.color"
                              thumb-size="25px"
                              height="70px"
                              tick-size="3px"
                              :tick-labels="ticksHt"
                              max="24"
                              step="1"
                              ticks="always"
                              thumb-label="always"
                      ></v-range-slider>
                    </div>
                    <div class="col-12 pa-0 d-flex std-text-sm std-text-gray-2 ">Recuerda que
                      el ciclo es de 21 días, pero este puede ser irregular.
                    </div>
                  </v-col>

                </v-row>
              </v-col>
            </v-fade-transition>
          </v-row>
          <!-- end of heat date range cards -->

          <!-- pregnant slider -->
          <v-row no-gutters
                 v-if="this.view === 'preg'">
            <v-col cols="12">
              <v-row no-gutters
                     class="mt-4 hf-right-header">
                <v-col class="d-flex std-text-blue-3 align-center justify-center std-text-md"
                       cols="12">Siguientes partos entre:</v-col>
              </v-row>
              <v-row no-gutters
                     class="mt-4 px-6">
                <v-col cols="12"
                       class="d-flex align-center flex-wrap">
                  <div class="col-12 pa-0">
                    <v-range-slider
                            dense
                            style="font-size: .875rem !important;"
                            class="font-weight-medium std-text-gray-2"
                            hide-details
                            v-model="slider"
                            min="1"
                            color="#979797"
                            track-color="#97F6D2"
                            thumb-color="#063664"
                            thumb-size="25px"
                            height="70px"
                            tick-size="3px"
                            :tick-labels="ticks"
                            max="9"
                            step="1"
                            ticks="always"
                            thumb-label="always"
                    ></v-range-slider>
                  </div>
                  <div class="col-12 pa-0 d-flex justify-center std-text-sm std-text-gray-2 font-weight-medium">Meses</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- end of pregnant slider -->

          <!-- vaccinates fields -->
          <v-row no-gutters
                 v-if="this.view === 'vacc'">
            <v-col cols="12">
              <v-fade-transition
                      mode="out-in">
                <v-row no-gutters
                       :key="0"
                       v-if="leftIndSelected === 'first'"
                       class="mt-4 hf-right-header">
                  <!-- vaccinate filter -->
                  <v-col class="d-flex align-center justify-center std-text-md"
                         :style="{color: this.color}"
                         cols="12">Filtro por vacuna:
                  </v-col>
                  <v-col cols="12" class="px-6 mt-2">
                    <v-select dense
                              :placeholder="vaccines[0]"
                              :items="vaccines"
                              outlined
                              hide-details>
                    </v-select>
                  </v-col>
                  <!-- end of vaccinate filter -->
                  <!-- dates range -->
                  <v-col class="d-flex align-center justify-center std-text-md mt-4"
                         :style="{color: this.color}"
                         cols="12">Rango de fechas:</v-col>
                  <v-col cols="12" class="px-6 mt-2">
                    <v-menu
                            v-model="vacc.trtPicker"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                                append-icon="mdi-calendar-blank"
                                outlined
                                dense
                                placeholder="DD/MM/AAAA"
                                readonly
                                required
                                v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                              :color="this.color"
                              v-model="vacc.rangeDate"
                              @input="vacc.trtPicker = false"
                              locale="es-419">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <!-- end of dates range -->
                </v-row>
                <v-row no-gutters
                       :key="1"
                       v-if="leftIndSelected === 'second'"
                       class="mt-4 hf-right-header">
                  <!-- dates range -->
                  <v-col class="d-flex align-center justify-center std-text-md"
                         :style="{color: this.color}"
                         cols="12">Rango de fechas:</v-col>
                  <v-col cols="12" class="px-6 mt-2">
                    <v-menu
                            v-model="vacc.trtPicker"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                                append-icon="mdi-calendar-blank"
                                outlined
                                dense
                                placeholder="DD/MM/AAAA"
                                readonly
                                required
                                v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                              :color="this.color"
                              v-model="vacc.rangeDate"
                              @input="vacc.trtPicker = false"
                              locale="es-419">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <!-- end of dates range -->
                </v-row>
              </v-fade-transition>
            </v-col>
          </v-row>
          <!-- end of vaccinates fields -->

          <!-- health fields -->
          <v-row no-gutters
                 v-if="this.view === 'health'">
            <v-col cols="12">
              <v-fade-transition
                      mode="out-in">
                <v-row no-gutters
                       justify="center"
                       class="mt-4 hf-right-header">
                  <!-- vaccinate filter -->
                  <v-col class="d-flex align-center justify-center std-text-md"
                         :style="{color: this.color}"
                         cols="12">Filtro por enfermedad:
                  </v-col>
                  <v-col cols="12" class="px-6 mt-2">
                    <v-select dense
                              :placeholder="diseases[0]"
                              :items="diseases"
                              outlined
                              v-model="diseaseSelected"
                              clearable
                              hide-details>
                    </v-select>
                  </v-col>
                  <!-- end of vaccinate filter -->
                </v-row>
              </v-fade-transition>
            </v-col>
          </v-row>

          <v-col cols="12"
                 class="pa-0 d-flex justify-center"
                 style="position: absolute; bottom: 12px"
                 v-if="view === 'health'">
            <v-btn class="d-flex justify-space-around std-btn-back std-text-white-1 std-text-xs col-11 pa-0"
                   style="font-size: 1rem !important; background-color: #65D9AC !important;"
                   color="#FF006A"
                   height="40px"
                   depressed>
              <div class="d-flex justify-space-between align-center">
                Vacunación y desarrollo
              </div>
            </v-btn>
          </v-col>
          <!-- end of health fields-->

        </v-col>
        <!-- end of  right lateral panel -->
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
    import {EventBus} from '@/views/bus';
    import moment from 'moment';
    import getFormattedNumber from '../mixins/formatting';
    import getAnimalsWithHeat from '../mixins/heats';

    export default {
        name: "HomeFullCard",
        mixins: [getFormattedNumber, getAnimalsWithHeat],
        props: {
            header: {
                type: String
            },
            single: {
                type: Boolean,
                default: false
            },
            color: {
                type: String
            },
            img: {
                type: String
            },
            view: {
                type: String
            },
            tableSecondColumn: {
                type: String,
            },
        },
        data() {
            return {
                pageSelected: 1,
                animalSelected: 'cow',
                slider: [1, 5],
                sliderHt: [20, 22],
                ticks: Array.from(Array(10), (_, i) => i + 1),
                ticksHt: [18, 19, 20, 21, 22, 23, 24],
                nextIcon: 'navigate_next',
                prevIcon: 'navigate_before',
                pageItem: {number: 6, formattedText: '6 eventos por hoja'},
                cows: [],
                heifers: [],
                pageItems: [
                    {number: 6, formattedText: '6 eventos por hoja'},
                ],
                vacc: {
                    rangeDate: moment().format('YYYY-MM-DD'),
                    trtPicker: false,
                },
                vaccines: ['Vacuna 1', 'Vacuna 2'],
                diseaseSelected: undefined,
                diseases: ['Mastitis', 'Brucelosis', 'Pulmonía', 'Cetosis', 'Tuberculosis', 'Cojera', 'Fiebre aftosa',
                'Envenenamiento', 'Otro'],
                leftIndSelected: 'first',
                heatFollowDates: [],
            }
        },
        computed: {
            cowsCount() {
                let cowsSize = this.cows.length;
                return this.getFormattedNumber(cowsSize);
            },
            heifersCount() {
                let heifersSize = this.heifers.length;
                return this.getFormattedNumber(heifersSize);
            },
            animals() {
                switch (this.view) {
                    case 'preg':
                        return this.getPregAnimals(this.slider[0], this.slider[1], this.animalSelected);
                    case 'heat':
                        return this.getHeatAnimals(this.sliderHt[0], this.sliderHt[1], this.animalSelected);
                    case 'health':
                        return this.getSelectedAnimals(this.animalSelected, this.diseaseSelected);
                    default:
                        return [];
                }
            },
            /**
             * Return the header of first column of table
             */
            tableFirstColumn() {
                if (this.animalSelected === 'cow') {
                    return "ID vaca"
                } else {
                    return "ID vaquilla";
                }
            },
            /**
             * Regresa los elementos de la bitácora de acuerdo a los eventos
             * por hoja seleccionados por el usuario
             */
            croppedHistory() {
                return this.$store.getters.getCows.slice((this.pageSelected - 1) * this.pageItem.number, this.pageSelected * this.pageItem.number);
            },
            /**
             * Calcula el número de páginas que mostrará la paginación
             */
            itemsPage() {
                return Math.floor(this.animals.length / this.pageItem.number) + 1;
            },
            /**
             * Gets the right style's properties in case of the animal selected is a calf
             * @returns {{border: string, color: string, background: string, icon: string}}
             */
            styleCalf() {
                let sty = {
                    icon: '',
                    background: '#FFFFFF',
                    color: "#979797",
                    border: "#979797",
                }
                if (this.animalSelected === 'calf') {
                    sty.icon = 'hf-calf-icon';
                    sty.color = '#FFFFFF';
                    sty.background = this.color;
                    sty.border = this.color;
                } else {
                    sty.icon = 'hf-calf-icon-disabled';
                }
                return sty;
            },
            /**
             * Gets the right style's properties in case of the animal selected is a cow
             * @returns {{border: string, color: string, background: string, icon: string}}
             */
            styleCow() {
                let sty = {
                    icon: '',
                    background: '#FFFFFF',
                    color: "#979797",
                    border: "#979797",
                }
                if (this.animalSelected === 'cow') {
                    sty.icon = 'hf-cow-icon';
                    sty.color = '#FFFFFF';
                    sty.background = this.color;
                    sty.border = this.color;
                } else {
                    sty.icon = 'hf-cow-icon-disabled';
                }
                return sty;
            },
            leftIndicator() {
                let indicator = {
                    first: {
                        title: '',
                        number: 0,
                    },
                    second: {
                        title: '',
                        number: 0,
                    },
                };
                let animalsSize = this.heifers.length + this.cows.length;
                let tmpAnimals = [];
                switch (this.view) {
                    case 'vacc':
                        indicator.first.title = 'Por vacunar';
                        indicator.second.title = 'A dar tratamiento';
                        break;
                    case 'health':
                        this.setLeftInd('second');
                        indicator.second.title = 'Enfermas';
                        indicator.second.number =  this.getFormattedNumber(animalsSize);
                        break;
                    case 'preg':
                        this.setLeftInd('second');
                        indicator.second.title = 'Preñadas'
                        indicator.second.number = this.getFormattedNumber(animalsSize);
                        break;
                    case 'heat':
                        tmpAnimals = this.animalSelected === 'calf' ? this.heifers : this.cows;
                        indicator.first.title = 'A revisar hoy';
                        indicator.first.number = this.getFormattedNumber(tmpAnimals.filter(animal => animal.heatCycle === 1).length);
                        indicator.second.title = 'Para seguimiento';
                        indicator.second.number = this.getFormattedNumber(tmpAnimals.filter(animal => animal.heatCycle !== 1).length);
                        break;
                    default:
                        indicator.first.title = 'A revisar hoy';
                        indicator.second.title = 'Para seguimiento';
                }
                return indicator;
            },
        },
        methods: {
            setSelectedAnl(animal) {
                this.animalSelected = animal;
            },
            close() {
                EventBus.$emit('close-full');
            },
            setLeftInd(ind) {
                this.leftIndSelected = ind;
            },
            /**
             * Obtains the current pregnant animals between two dates
             * @param low
             * @param high
             * @param type
             * @returns {*}
             */
            getPregAnimals(low, high, type) {
                let tmpAnimals = type === 'calf' ? this.heifers : this.cows;
                let max = moment().subtract((low - 1) * 30, 'd');
                let min = moment().subtract(high * 30, 'd');
                return tmpAnimals.filter(animal => moment(animal.pregDate).isBetween(min.toISOString(), max.toISOString()))
            },
            getHeatAnimals(low, high, type) {
                let tmpAnimals = type === 'calf' ? this.heifers : this.cows;
                if (this.leftIndSelected === 'first') {
                    return tmpAnimals;
                } else {
                    return tmpAnimals.filter(animal => animal.heatDay >= low && animal.heatDay <= high);
                }
            },
            getSelectedAnimals(type, disease) {
                let tmpAnimals = type === 'calf' ? this.heifers : this.cows;
                if (disease === undefined) {
                    return tmpAnimals;
                } else {
                    return tmpAnimals.filter(animal => animal.health.sick === disease);
                }
            }
        },
        created() {
            switch (this.view) {
                case 'preg':
                    this.cows = this.$store.getters.getCows.filter(cow => cow.pregDate);
                    break;
                case 'heat':
                    this.cows = this.getAnimalsWithHeat(this.$store.getters.getCows);
                    break;
                case 'health':
                    this.cows = this.$store.getters.getCows.filter(cow => cow.health);
                    break;
            }
        }
    }
</script>

<style scoped>
  .hf-header-container {
    height: 40px;
  }

  .hf-main-container {
    height: 472px;
  }

  .hf-close-icon {
    background: url("../assets/home/close.svg") no-repeat;
    height: 30px;
    width: 30px;
  }

  .hf-left-sm-container {
    height: 142px;
  }

  .hf-left-container {
    height: 165px;
    color: var(--smartbell-blue-3);
    font-size: 6.5rem;
  }

  .hf-left-image-container {
    height: 120px;
  }

  .hf-break {
    background-color: #979797;
    height: 2px;
    width: 100%;
  }

  .hf-table-container {
    height: 384px;
  }

  .hf-table-paginator {
    height: 68px;
  }

  .hf-animal-count {
    height: 44px;
    border: 2px solid;
    border-radius: 4px;
  }

  .hf-calf-icon {
    background: url("../assets/home/calf.svg") no-repeat;
    height: 29px;
    width: 50px;
  }

  .hf-cow-icon {
    background: url("../assets/home/cow.svg") no-repeat;
    height: 29px;
    width: 50px;
  }

  .hf-cow-icon-disabled {
    background: url("../assets/home/cow_blue.svg") no-repeat;
    height: 29px;
    width: 50px;
  }

  .hf-calf-icon-disabled {
    background: url("../assets/home/calf_blue.svg") no-repeat;
    height: 29px;
    width: 50px;
  }

  .hf-right-header {
    height: 40px;
  }

  .v-input--selection-controls {
    margin: 0;
    padding: 0;
  }


</style>